module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Article.82be2ae1.jpg";